import { parseMediaFromCMS } from '@/utils/image';
import NextImage, { ImageProps, StaticImageData } from 'next/image';
import { memo } from 'react';

interface StaticRequire {
  default: StaticImageData;
}

interface ImagePropTypes extends Omit<ImageProps, 'src' | 'alt'> {
  src?: string; // | StaticImageData | StaticRequire;
  alt?: string;
  cmsImage?: any;
}

const Image = ({ src, alt, width, height, className, cmsImage, ...rest }: ImagePropTypes) => {
  let imageSrc = src;
  let imageAlt = alt;

  if (cmsImage) {
    const image = parseMediaFromCMS(cmsImage);
    imageSrc = image.src;
    imageAlt = image.alt;
  }

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      alt={imageAlt ?? ''}
      src={imageSrc ?? ''}
      width={width}
      height={height}
      className={className}
      {...rest}
    />
  );
};

export default memo(Image);
